module.exports = __webpack_public_path__ + "static/media/trackLeavesEasilyIcon.63d22aa2.svg";